'use strict';

angular.module('MoreGrid', []);
